import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactToPrint from 'react-to-print';
import StyledButton from './styled-components/StyledButton';

const ButtonText = styled.span`
  height: 23px;
  font-size: 16px;
  font-weight: 500;
  line-height: 23px;
  text-align: center;
`;

// eslint-disable-next-line react/prefer-stateless-function
class PrintButton extends Component {
  render() {
    const {
      text,
      content,
      primary,
      onClick,
      fullWidth,
      disabled,
    } = this.props;

    return (
      <div>
        <ReactToPrint
          trigger={() => (
            <StyledButton disabled={disabled} fullWidth={fullWidth} primary={primary} onClick={onClick} type="button">
              <ButtonText>
                {text}
              </ButtonText>
            </StyledButton>
          )}
          content={() => this.printRef}
        />
        <div ref={(el) => { this.printRef = el; }}>
          {content}
        </div>
      </div>
    );
  }
}

PrintButton.defaultProps = {
  primary: false,
  disabled: false,
  fullWidth: false,
  onClick: () => null,
};

PrintButton.propTypes = {
  text: PropTypes.object.isRequired,
  content: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  primary: PropTypes.bool,
  onClick: PropTypes.func,
};

export default PrintButton;
